import './App.css';
import React, { Component } from 'react';
import  DisplayLabo  from './Components/DisplayLabo';
import { DisplayWetenschappelijkWerk } from './Components/DisplayWetenschappelijkWerk';
import DisplayStaalAfname from './Components/DisplayStaalAfname';

import { Link, Route, Switch } from "react-router-dom";
import { polyfillLoader } from 'polyfill-io-feature-detection';



import { polyfill } from 'es6-promise';
polyfill();
export default function Application() {

    return ( <div>
        <Switch>
  <Route exact path="/Staalafname">
    <DisplayStaalAfname />
  </Route>

  <Route path="/Staalafname/:title">
    <DisplayStaalAfname fullScreen />
  </Route>

  <Route exact path="/Labogids">
    <DisplayLabo />
  </Route>

  <Route path="/Labogids/:title">
    <DisplayLabo fullScreen />
  </Route>

  <Route path="/WetenschappelijkWerk">
    <DisplayWetenschappelijkWerk />
  </Route>
</Switch>
        </div>);
    }